import { Col, Row, Spin } from "antd";
import React, { useState, useEffect, useRef } from "react";
import ReactEcharts from "echarts-for-react";
import { o_xy, o_p_xy } from "./option";
import { getXYdata, getTXYdata } from "@/services/propsApi";
import { Md5 } from "md5-typescript";

// caslist:any, T: any,VF:any=0,method:any="SRK",npoints:any=20

const Component = (props: any) => {
  const { source } = props;
  const [caslist, setCaslist] = useState<any>(null); //cas列表
  const [T, setT] = useState<any>(298.15); //温度
  const [VF, setVF] = useState<any>(0); //气相分数
  const [method, setMethod] = useState<any>("SRK"); //方法
  const [npoints, setpoints] = useState<any>(50); //计算点数
  const [xydata, setXYdata] = useState<any>([]); //xy数据
  const [txydata, setTXYdata] = useState<any>([]); //Txy数据

  const [axisMaxValues, setAxisMaxValues] = useState<any>(null);

  //           alignItems: "center",

  useEffect(() => {
    setCaslist(source.map((item: any) => item.cas_code));
  }, [source]);

  useEffect(() => {
    if (caslist) {
      getXYdata(caslist, T, VF, method, npoints).then((res) => {
        setXYdata(res.data.data);
        getTXYdata(caslist, T, method, npoints).then((res) => {
          setTXYdata(res.data.data);
        });
      });
    }
  }, [caslist, T, VF, method, npoints]);

  const chartRef = useRef(null);

  const updateChart = () => {
    if (chartRef.current) {
      // 获取 ECharts 实例
      const echartsInstance = chartRef.current.getEchartsInstance();

      // 获取当前的配置项
      // const option = echartsInstance.getOption();
      const yAxisModel = echartsInstance.getModel().getComponent("yAxis", 0);
      // const xAxisModel = echartsInstance.getModel().getComponent('xAxis', 0);
      if (yAxisModel && yAxisModel.axis) {
        // 2. 从 ComponentModel 中获取真正的 Axis 实例
        const yAxis = yAxisModel.axis.scale._extent[1];

        setAxisMaxValues(yAxis);
        // // 3. 调用 Axis 实例的 getExtent() 方法获取 [min, max]
        // const extent = yAxis.getExtent(); // 返回 [min, max]
        // // const max = extent[1]; // 最大值

        console.log("ECharts 内部使用的 yAxis 最大值:", yAxis);
      } else {
        console.error("无法获取 yAxis 的 Axis 实例");
      }
    }
  };

  useEffect(() => {
    if (axisMaxValues) {
      updateChart();
    }
  }, [Md5.init(axisMaxValues)]);

  return (
    <Row>
      <Col span={24}>
        <div className="showptxCharts">
          {axisMaxValues !== null ? (
            ""
          ) : (
            <div className="loadingArea2">
              <Spin />
            </div>
          )}
          <div
            className="showChartArea"
            style={{ visibility: axisMaxValues ? "visible" : "hidden" }}
          >
            <ReactEcharts
              option={o_xy(xydata)}
              notMerge={true}
              lazyUpdate={true}
              style={{ height: "100%", width: "100%" }}
            />
          </div>
        </div>
      </Col>
      <Col span={24}>
        <div className="showptxCharts">
          {axisMaxValues !== null ? (
            ""
          ) : (
            <div className="loadingArea2">
              <Spin />
            </div>
          )}
          <div
            className="showChartArea"
            style={{ visibility: axisMaxValues ? "visible" : "hidden" }}
          >
            <ReactEcharts
              // option={o_p_xy(txydata,axisMaxValues)}
              option={o_p_xy(txydata, axisMaxValues)}
              notMerge={true}
              lazyUpdate={true}
              ref={chartRef}
              style={{ height: "100%", width: "100%" }}
              onEvents={{
                finished: updateChart,
                // dataZoom: onDataZoom,
                // 可以添加其他需要监听的事件
              }}
            />
          </div>
        </div>

        {/* <div onClick={getAxisMaxValue}>zuidazhi</div> */}
      </Col>
    </Row>
  );
};

export default Component;
